import React from 'react';
import './Websites.css';
import { useNavigate } from 'react-router-dom';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import HomeIcon from '@mui/icons-material/Home';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SchoolIcon from '@mui/icons-material/School';

const saleImg = require('./sale.jpg');
const stripeImg = require('./stripe.png');

const Websites = () => {
  const navigate = useNavigate();

  return (
    <div className="websites-page">
      <div className="hero-wrapper">
        <div className="hero-left">
          <div
            className="hero-image"
            style={{
              backgroundImage: `linear-gradient(rgba(0,0,0,0.22), rgba(0,0,0,0.22)), url(${saleImg})`,
            }}
          />
          {/* mobile overlay removed; content lives in the right card for consistency */}
        </div>

        <div className="hero-right">
          <div className="hero-card">
            <h2>Take your brand to the next level</h2>
            <p>
              Relying on social media to get the word out
              but don’t have a professional website to display your products and offerings?
              Let us build you a fully custom website designed to help you grow!
            </p>
          </div>
        </div>
      </div>

      <div className="websites-content">
        {/* Additional page content will go here */}
      </div>
      <section className="customization-section">
        <div className="salesTextPort">
          <div className="salesTextTop2">
            <h2 className="salesTitle">Complete Customization</h2>
            <p className="salesParagraph">
              We know every business has unique processes that are vital to its
              success and daily operations. That's why we work closely with you to ensure everything looks and functions exactly the way you need.</p>
          </div>
        </div>
        <section className="comparison-section">
          <div className="websites-content">
            <div className="compare-card">
              <div className="compare-table-wrap">
                <table className="compare-table" aria-label="Competitors vs Our Websites features">
                  <thead>
                    <tr>
                      <th>Competitors</th>
                      <th>Our Websites</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Platforms like WordPress and Squarespace offer cookie-cutter templates</td>
                      <td>We'll build you 1 of 1 components that are uniquely tailored to your business</td>
                    </tr>
                    <tr>
                      <td>Our competitors have recurring monthly subscription fees</td>
                      <td>We do zero monthly fees. Once we build your site, it's yours.</td>
                    </tr>

                    <tr>
                      <td>These companies make YOU design the site yourself, which can feel overwhelming if you have no experience and don't know where to start</td>
                      <td>We handle all design work and offer multiple rounds of feedback to ensure your website looks great and functions perfectly.</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </section>

      <section className="industry-section">
        <div className="salesTextPort">
          <div className="salesTextTop2">
            <h2 className="salesTitle">Websites Built for Every Industry</h2>

            <p className="salesParagraph">
              Whether you’re selling products, offering services, or coaching clients, we build websites that work the way you do.
            </p>
          </div>
        </div>

        <div className="websites-content">
          <div className="industry-grid">
            <div className="industry-card">
              <div className="industry-icon"><CheckroomIcon fontSize="large" /></div>
              <h4 style={{ fontFamily: 'Bold', fontWeight: 200 }}>Clothing</h4>
              <p className="industry-card-desc">Sell products online with inventory, collections, and promos.</p>
            </div>

            <div className="industry-card">
              <div className="industry-icon"><HomeIcon fontSize="large" /></div>
              <h4 style={{ fontFamily: 'Bold', fontWeight: 200 }}>Services</h4>
              <p className="industry-card-desc">Bookings, staff pages and service packages made simple.</p>
            </div>

            <div className="industry-card">
              <div className="industry-icon"><RestaurantIcon fontSize="large" /></div>
              <h4 style={{ fontFamily: 'Bold', fontWeight: 200 }}>Food</h4>
              <p className="industry-card-desc">Menus, online ordering, and reservations built for speed.</p>
            </div>

            <div className="industry-card">
              <div className="industry-icon"><SchoolIcon fontSize="large" /></div>
              <h4 style={{ fontFamily: 'Bold', fontWeight: 200 }}>Coaching</h4>
              <p className="industry-card-desc">Client bookings, progress tracking, and resource hubs.</p>
            </div>
          </div>


        </div>
      </section>

      <section className="stripe-section">
        <div className="websites-content">
          <div className="stripe-card">
            <img src={stripeImg} alt="Stripe logo" className="stripe-img" />
            <div className="stripe-copy">
              <h3>Process Customer Payments with Stripe</h3>
              <p className="stripe-desc">
                We use Stripe to power secure payments on your website, giving you access to trusted payment tools used by businesses worldwide.
              </p>

              <ul className="stripe-bullets">
                <p className="stripe-desc">
                  This includes features like:
                </p>


                <li>Flexible shipping types & tax support</li>

                <li>Built-in fraud protection & dispute management</li>
                <li>Inventory & order management integration</li>
                <li>Insights and data analysis</li>
                <li>Low processing fees</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="price-card stripe-card">
          <div className="price-copy">
            <h3 className="price-title">Your dream website, all for <span className="price-amount">$1,500</span></h3>
            <p className="price-desc">This includes everything you need to launch and start growing your business online</p>

            <div className="pricing-grid price-pills">
              <div className="pricing-pill">Multiple rounds of development</div>
              <div className="pricing-pill">Logo, branding, and font selection</div>
              <div className="pricing-pill">Assistance with Stripe integration</div>
              <div className="pricing-pill">24/7 support after launch</div>
            </div>

            <div className="pricing-cta">
              <p className="pricing-ask">Want to see what we can do for your business?</p>
              <button type="button" className="btn-primary" onClick={() => navigate('/contact')}>Book consultation</button>
            </div>
          </div>
        </div>

      </section>

    </div>
  );
};

export default Websites;
